export default [
  { text: 'PIN', value: 'pin' },
  { text: 'SalesOrder', value: 'sonum' },
  { text: 'Created By', value: 'userName' },
  { text: 'Valid Until', value: 'ttl' },
  // { text: 'Alive', value: 'alive' },
  { text: 'CreatedAt', value: 'createdAt' },
  { text: '', value: 'actions' }
];
